<div mat-dialog-title class="rowFlexNoWrap">
  <div class="rowText">Gestiones</div>
  <div class="rowText">
    Total Gestiones Madre: {{ totalGestionesMadre }} Total Gestiones Hija:
    {{ totalGestionesHija }}
  </div>

  <button
    mat-button
    mat-dialog-close
    class="close-button"
    style="margin-left: auto"
  >
    <img
      src="../../../assets/icons/cerrar.png"
      alt="Alternate Text"
      style="height: 30px; width: 30px"
    />
  </button>
</div>

<mat-dialog-content
  class="mat-typography"
  style="height: 91%; max-height: 91% !important"
>
  <!--************GRID***********-->
  <!--<div class="SectionGrids">-->
  <!--************Encabezado***********-->

  <div
    class="flexRowNoWrap EncabezadoGridR1"
    style="
      justify-content: space-between;
      flex-wrap: nowrap;
      min-height: 36px;
      min-width: 2600px;
    "
  >
    <div class="cellListP" style="width: 40px; min-width: 40px">
      <div class="cellListE1">&nbsp;</div>
    </div>

    <div class="cellListP" style="width: 15px; min-width: 15px">
      <div class="cellListE1">&nbsp;</div>
    </div>

    <div class="cellListP" style="min-width: 130px">
      <div class="cellListE1"><span>Gestion</span></div>
    </div>

    <div class="cellListP" style="min-width: 130px">
      <div class="cellListE1"><span>Cliente</span></div>
    </div>

    <div class="cellListP" style="min-width: 130px">
      <div class="cellListE1"><span>Proveedor</span></div>
    </div>

    <div class="cellListP" style="min-width: 80px">
      <div class="cellListE1"><span>USD</span></div>
    </div>

    <div class="cellListP" style="min-width: 100px">
      <div class="cellListE1"><span>Estado</span></div>
    </div>

    <div class="cellListP" style="min-width: 120px">
      <div class="cellListE1"><span>Diferencia T. Meta y Proceso</span></div>
    </div>

    <div class="cellListP" style="min-width: 100px">
      <div class="cellListE1"><span>ETA</span></div>
    </div>

    <div class="cellListP" style="min-width: 200px">
      <div class="cellListE1"><span>Sitio Actual /Segmento Actual</span></div>
    </div>

    <div class="cellListP" style="min-width: 100px">
      <div class="cellListE1"><span>Ultimo Sello</span></div>
    </div>

    <div class="cellListP" style="min-width: 100px">
      <div class="cellListE1"><span>Fecha Ultimo Sello</span></div>
    </div>

    <div class="cellListP" style="min-width: 100px">
      <div class="cellListE1"><span>No. Factura Comercial</span></div>
    </div>

    <div class="cellListP" style="min-width: 100px">
      <div class="cellListE1"><span>Orden De Compra</span></div>
    </div>

    <div class="cellListP" style="min-width: 120px">
      <div class="cellListE1"><span>Doc. Transporte</span></div>
    </div>

    <div class="cellListP" style="min-width: 120px">
      <div class="cellListE1"><span>Placa Cabezal</span></div>
    </div>

    <div class="cellListP" style="min-width: 120px">
      <div class="cellListE1"><span>Placa Furgon</span></div>
    </div>

    <div class="cellListP" style="min-width: 400px; max-width: 400px">
      <div class="cellListE1"><span>Notas</span></div>
    </div>

    <div class="cellListP" style="min-width: 55px">
      <div class="cellListE1"><span>Eventos</span></div>
    </div>

    <div class="cellListP" style="min-width: 55px">
      <div class="cellListE1"><span>Alertas</span></div>
    </div>

    <div class="cellListP" style="min-width: 75px">
      <div class="cellListE1"><span>Incidencias</span></div>
    </div>

    <div class="cellListP" style="min-width: 55px">
      <div class="cellListE1"><span>Casos</span></div>
    </div>

    <div class="cellListP" style="min-width: 55px">
      <div class="cellListE1"><span>Carga</span></div>
    </div>

    <div class="cellListP" style="min-width: 55px">
      <div class="cellListE1"><span>Bitacora</span></div>
    </div>
  </div>

  <!--************Filtros***********-->
  <div class="flexRowNoWrap headerFiltros" style="min-width: 2600px">
    <div class="cellListP" style="width: 40px; min-width: 40px">
      <div class="cellListE1">&nbsp;</div>
    </div>

    <div class="cellListP" style="width: 15px; min-width: 15px">
      <div class="cellListE1">&nbsp;</div>
    </div>

    <div class="cellListP" style="min-width: 130px">
      <div class="cellListE1">
        <input
          type="text"
          name="NumeroGestion"
          style="width: 100%; box-sizing: border-box"
        />
      </div>
    </div>

    <div class="cellListP" style="min-width: 130px">
      <div class="cellListE1">
        <input
          type="text"
          name="ClienteNombre"
          style="width: 100%; box-sizing: border-box"
        />
      </div>
    </div>

    <div class="cellListP" style="min-width: 130px">
      <div class="cellListE1">
        <input
          type="text"
          name="ConsignatarioNombre"
          style="width: 100%; box-sizing: border-box"
        />
      </div>
    </div>

    <div class="cellListP" style="min-width: 80px">
      <div class="cellListE1">
        <input
          type="text"
          name="CostoTotal"
          style="width: 100%; box-sizing: border-box"
        />
      </div>
    </div>

    <div class="cellListP" style="min-width: 100px">
      <div class="cellListE1">
        <input
          type="text"
          name="Estado"
          style="width: 100%; box-sizing: border-box"
        />
      </div>
    </div>

    <div class="cellListP" style="min-width: 120px">
      <div class="cellListE1">&nbsp;</div>
    </div>

    <div class="cellListP" style="min-width: 100px">
      <div class="cellListE1">
        <input
          type="text"
          name="ETA"
          style="width: 100%; box-sizing: border-box"
        />
      </div>
    </div>

    <div class="cellListP" style="min-width: 200px">
      <div class="cellListE1">
        <input
          type="text"
          name="SitioActual"
          style="width: 100%; box-sizing: border-box"
        />
      </div>
    </div>

    <div class="cellListP" style="min-width: 100px">
      <div class="cellListE1">
        <input
          type="text"
          name="UltimoSelloNombre"
          style="width: 100%; box-sizing: border-box"
        />
      </div>
    </div>

    <div class="cellListP" style="min-width: 100px">
      <div class="cellListE1">
        <input
          type="text"
          name="UltimoSello"
          style="width: 100%; box-sizing: border-box"
        />
      </div>
    </div>

    <div class="cellListP" style="min-width: 100px">
      <div class="cellListE1">
        <input
          type="text"
          name="CostosFacturacion"
          style="width: 100%; box-sizing: border-box"
        />
      </div>
    </div>

    <div class="cellListP" style="min-width: 100px">
      <div class="cellListE1">&nbsp;</div>
    </div>

    <div class="cellListP" style="min-width: 120px">
      <div class="cellListE1">
        <input
          type="text"
          name="DocumentosTransporte"
          style="width: 100%; box-sizing: border-box"
        />
      </div>
    </div>

    <div class="cellListP" style="min-width: 120px">
      <div class="cellListE1">
        <input
          type="text"
          name="PlacaCabezal"
          style="width: 100%; box-sizing: border-box"
        />
      </div>
    </div>

    <div class="cellListP" style="min-width: 120px">
      <div class="cellListE1">
        <input
          type="text"
          name="PlacaFurgon"
          style="width: 100%; box-sizing: border-box"
        />
      </div>
    </div>

    <div class="cellListP" style="min-width: 400px; max-width: 400px">
      <div class="cellListE1">
        <input
          type="text"
          name="Notas"
          style="width: 100%; box-sizing: border-box"
        />
      </div>
    </div>

    <div class="cellListP" style="min-width: 55px">
      <div class="cellListE1">
        <input
          type="text"
          name="Eventos"
          style="width: 100%; box-sizing: border-box"
        />
      </div>
    </div>

    <div class="cellListP" style="min-width: 55px">
      <div class="cellListE1">
        <input
          type="text"
          name="Alertas"
          style="width: 100%; box-sizing: border-box"
        />
      </div>
    </div>

    <div class="cellListP" style="min-width: 75px">
      <div class="cellListE1">
        <input
          type="text"
          name="Incidencias"
          style="width: 100%; box-sizing: border-box"
        />
      </div>
    </div>

    <div class="cellListP" style="min-width: 55px">
      <div class="cellListE1">
        <input
          type="text"
          name="Casos"
          style="width: 100%; box-sizing: border-box"
        />
      </div>
    </div>

    <div class="cellListP" style="min-width: 55px">
      <div class="cellListE1">&nbsp;</div>
    </div>

    <div class="cellListP" style="min-width: 55px">
      <div class="cellListE1">&nbsp;</div>
    </div>
  </div>

  <!--************Body grids***********-->

  <div
    class="subsection"
    style="height: 84%; min-width: 2600px; overflow-y: auto; overflow-x: hidden"
  >
    <div *ngFor="let item of newArrayGestion; let i = index">
      <!-- Fila principal -->
      <div class="flexRowNoWrap rowGrid">
        <!-- Columna 1: Ícono expandible -->
        <div class="cellListP" style="width: 40px; min-width: 40px">
          <div
            class="cellListE1 c-pointer"
            (click)="item.Expandible = !item.Expandible"
          >
            <img
              *ngIf="!item.Expandible"
              src="../../../assets/icons/arrowDownBlack1.png"
              alt="Expandir"
            />
            <img
              *ngIf="item.Expandible"
              src="../../../assets/icons/arrowUpBlack1.png"
              alt="Contraer"
            />
          </div>
        </div>

        <!-- Columna 2: Número de fila -->
        <div class="cellListP" style="width: 15px; min-width: 15px">
          <div class="cellListE1">
            <span>{{ i + 1 }}</span>
          </div>
        </div>

        <!-- Columna 3: Gestión -->
        <div class="cellListP" style="min-width: 130px">
          <div class="cellListE1">
            <span>{{ item.NumeroGestion }}</span>
          </div>
        </div>

        <!-- Columna 4: Cliente -->
        <div class="cellListP" style="min-width: 130px">
          <div class="cellListE1">
            <span>{{ item.ClienteNombre }}</span>
          </div>
        </div>

        <!-- Columna 5: Proveedor -->
        <div class="cellListP" style="min-width: 130px">
          <div class="cellListE1">
            <span>{{ item.ConsignatarioNombre }}</span>
          </div>
        </div>

        <!-- Columna 6: USD -->
        <div class="cellListP" style="min-width: 80px">
          <div
            class="cellListE1"
            style="justify-content: flex-end; padding-right: 8px"
          >
            <span>${{ item.CostoTotal | commaDecimal }}</span>
          </div>
        </div>

        <!-- Columna 7: Estado -->
        <div class="cellListP" style="min-width: 100px">
          <div class="cellListE1">
            <span>{{ item.Estado.DisplayName }}</span>
          </div>
        </div>

        <!-- Columna 8: Diferencia Tiempo -->
        <div class="cellListP" style="min-width: 120px">
          <div class="cellListE1">
            <span [title]="getTooltipText(item)">
              {{ obtenerDiferenciaTiempoMetaEnDiasTiempoProceso(item) }}
            </span>
          </div>
        </div>

        <!-- Columna 9: ETA -->
        <div class="cellListP" style="min-width: 100px">
          <div class="cellListE1">
            <span>{{ item.ETA }}</span>
          </div>
        </div>

        <!-- Columna 10: Sitio Actual -->
        <div class="cellListP" style="min-width: 200px">
          <div class="cellListE1">
            <span>{{ item.SitioActual }}</span>
          </div>
        </div>

        <!-- Columna 11: Último Sello -->
        <div class="cellListP" style="min-width: 100px">
          <div class="cellListE1">
            <span>{{ item.UltimoSelloNombre }}</span>
          </div>
        </div>

        <!-- Columna 12: Fecha Último Sello -->
        <div class="cellListP" style="min-width: 100px">
          <div class="cellListE1">
            <span>{{ item.UltimoSello }}</span>
          </div>
        </div>

        <!-- Columna 13: Factura Comercial -->
        <div class="cellListP" style="min-width: 100px">
          <div class="cellListE1">
            <span>{{ item.CostosFacturacion[0]?.NumeroFactura }}</span>
          </div>
        </div>

        <div class="cellListP" style="min-width: 100px">
          <div class="cellListE1">
            <span>{{ obtenerOrdenDeCompra(item) }}</span>
          </div>
        </div>

        <!-- Columna 14: Doc. Transporte -->
        <div class="cellListP" style="min-width: 120px">
          <div class="cellListE1">
            <span>{{ item.DocumentosTransporte[0]?.Referencia }}</span>
          </div>
        </div>

        <!-- Columna 15: Placa Cabezal -->
        <div class="cellListP" style="min-width: 120px">
          <div class="cellListE1">
            <span>{{ item?.PlacaCabezal }}</span>
          </div>
        </div>

        <!-- Columna 16: Placa Furgón -->
        <div class="cellListP" style="min-width: 120px">
          <div class="cellListE1">
            <span>{{ item?.PlacaFurgon }}</span>
          </div>
        </div>

        <!-- Columna 17: Notas -->
        <div
          id="Notas"
          (click)="MostrarNotas(item)"
          class="cellListP"
          style="min-width: 400px; max-width: 400px; cursor: pointer"
          [title]="obtenerUltimaObservacion(item)"
        >
          <div class="cellListE1">
            <span>{{ truncarTexto(obtenerUltimaObservacion(item), 100) }}</span>
          </div>
        </div>

        <!-- Columna 18: Eventos -->
        <div
          id="Eventos"
          (click)="MostrarEventos(item)"
          class="cellListP"
          style="min-width: 55px; cursor: pointer"
        >
          <div class="cellListE1" style="justify-content: center">
            <span
              [ngStyle]="{
                color: mostrarEventosAbiertos(item).tieneAbiertos
                  ? '#c38d08'
                  : 'black'
              }"
            >
              {{ mostrarEventosAbiertos(item).totalEventos }}
            </span>
          </div>
        </div>

        <!-- Columna 19: Alertas -->
        <div
          id="Alertas"
          (click)="MostrarAlertas(item)"
          class="cellListP"
          style="min-width: 55px; cursor: pointer"
        >
          <div class="cellListE1" style="justify-content: center">
            <span
              [ngStyle]="{
                color:
                  mostrarAlertasColor(item).totalAlertas > 0
                    ? '#c38d08'
                    : 'black'
              }"
            >
              {{ mostrarAlertasColor(item).totalAlertas }}
            </span>
          </div>
        </div>

        <!-- Columna 20: Incidencias -->
        <div class="cellListP" style="min-width: 75px">
          <div class="cellListE1" style="justify-content: center">
            <span>{{ item.Incidencias?.length }}</span>
          </div>
        </div>

        <!-- Columna 21: Casos -->
        <div class="cellListP" style="min-width: 55px">
          <div class="cellListE1" style="justify-content: center">
            <span>{{ item.Casos?.length }}</span>
          </div>
        </div>

        <!-- Columna 22: Carga -->
        <div class="cellListP" style="min-width: 55px">
          <div class="cellListE1" style="justify-content: center">
            <button class="buttonTransparente" (click)="EventModalCarga(item)">
              <img
                src="../../../assets/icons/Cargas.png"
                alt="Cargas"
                style="height: 24px"
              />
            </button>
          </div>
        </div>

        <!-- Columna 23: Bitácora -->
        <div class="cellListP" style="min-width: 55px">
          <div class="cellListE1" style="justify-content: center">
            <button
              class="buttonTransparente"
              (click)="EventModalBitacora(item)"
            >
              <img
                src="../../../assets/icons/bitacora.png"
                alt="Bitácora"
                style="height: 24px"
              />
            </button>
          </div>
        </div>
      </div>

      <!--**********expandible 1-->
      <div *ngIf="item.Expandible" class="SectionGrids SectionGridsH">
        <div class="subsection" style="background-color: #f8f9fa">
          <div *ngFor="let gestionhija of item.GestionesHijas; let j = index">
            <div class="flexRowNoWrap rowGrid">
              <!-- Columna 1: Espacio vacío para alinear con ícono de expansión -->
              <div class="cellListP" style="width: 40px; min-width: 40px">
                <div class="cellListE1">&nbsp;</div>
              </div>

              <!-- Columna 2: Índice -->
              <div class="cellListP" style="width: 15px; min-width: 15px">
                <div class="cellListE1">
                  <span>{{ j + 1 }}</span>
                </div>
              </div>

              <!-- Columna 3: Gestión hija -->
              <div class="cellListP" style="min-width: 130px">
                <div class="cellListE1">
                  <span>{{ gestionhija.NumeroGestion }}</span>
                </div>
              </div>

              <!-- Columna 4: Cliente -->
              <div class="cellListP" style="min-width: 130px">
                <div class="cellListE1">
                  <span>{{ gestionhija.ClienteNombre }}</span>
                </div>
              </div>

              <!-- Columna 5: Proveedor -->
              <div class="cellListP" style="min-width: 130px">
                <div class="cellListE1">
                  <span>{{ item.ConsignatarioNombre }}</span>
                </div>
              </div>

              <!-- Columna 6: USD -->
              <div class="cellListP" style="min-width: 80px">
                <div
                  class="cellListE1"
                  style="justify-content: flex-end; padding-right: 8px"
                >
                  <span>${{ gestionhija.CostoTotal | commaDecimal }}</span>
                </div>
              </div>

              <!-- Columna 7: Estado -->
              <div class="cellListP" style="min-width: 100px">
                <div class="cellListE1">
                  <span>{{ gestionhija.Estado.DisplayName }}</span>
                </div>
              </div>

              <!-- Columna 8: Diferencia Tiempo -->
              <div class="cellListP" style="min-width: 120px">
                <div class="cellListE1">
                  <span>{{
                    obtenerDiferenciaTiempoMetaEnDiasTiempoProceso(gestionhija)
                  }}</span>
                </div>
              </div>

              <!-- Columna 9: ETA -->
              <div class="cellListP" style="min-width: 100px">
                <div class="cellListE1">
                  <span>{{ gestionhija.ETA }}</span>
                </div>
              </div>

              <!-- Columna 10: Sitio Actual -->
              <div class="cellListP" style="min-width: 200px">
                <div class="cellListE1">
                  <span>{{ gestionhija.SitioActualModal }}</span>
                </div>
              </div>

              <!-- Columna 11: Último Sello -->
              <div class="cellListP" style="min-width: 100px">
                <div class="cellListE1">
                  <span>{{ gestionhija.UltimoSelloNombre }}</span>
                </div>
              </div>

              <!-- Columna 12: Fecha Último Sello -->
              <div class="cellListP" style="min-width: 100px">
                <div class="cellListE1">
                  <span>{{ gestionhija.UltimoSello }}</span>
                </div>
              </div>

              <!-- Columna 13: Factura Comercial -->
              <div class="cellListP" style="min-width: 100px">
                <div class="cellListE1">
                  <span>{{
                    gestionhija.CostosFacturacion[0]?.NumeroFactura
                  }}</span>
                </div>
              </div>

              <div class="cellListP" style="min-width: 100px">
                <div class="cellListE1">
                  <span>{{ obtenerOrdenDeCompra(gestionhija) }}</span>
                </div>
              </div>

              <!-- Columna 14: Doc. Transporte -->
              <div class="cellListP" style="min-width: 120px">
                <div class="cellListE1">
                  <span>{{
                    gestionhija.DocumentosTransporte[0]?.Referencia
                  }}</span>
                </div>
              </div>

              <!-- Columna 15: Placa Cabezal -->
              <div class="cellListP" style="min-width: 120px">
                <div class="cellListE1">
                  <span>{{ gestionhija?.PlacaCabezal }}</span>
                </div>
              </div>

              <!-- Columna 16: Placa Furgón -->
              <div class="cellListP" style="min-width: 120px">
                <div class="cellListE1">
                  <span>{{ gestionhija?.PlacaFurgon }}</span>
                </div>
              </div>

              <!-- Columna 17: Notas -->
              <div
                id="Notas"
                (click)="MostrarNotas(gestionhija)"
                class="cellListP"
                style="min-width: 400px; max-width: 400px; cursor: pointer"
                [title]="obtenerUltimaObservacion(gestionhija)"
              >
                <div class="cellListE1">
                  <span>{{
                    truncarTexto(obtenerUltimaObservacion(gestionhija), 100)
                  }}</span>
                </div>
              </div>

              <!-- Columna 18: Eventos -->
              <div
                (click)="MostrarEventos(gestionhija)"
                class="cellListP"
                style="min-width: 55px; cursor: pointer"
              >
                <div class="cellListE1" style="justify-content: center">
                  <span
                    [ngStyle]="{
                      color: mostrarEventosAbiertos(gestionhija).tieneAbiertos
                        ? '#c38d08'
                        : 'black'
                    }"
                  >
                    {{ mostrarEventosAbiertos(gestionhija).totalEventos }}
                  </span>
                </div>
              </div>

              <!-- Columna 19: Alertas -->
              <div
                (click)="MostrarAlertas(gestionhija)"
                class="cellListP"
                style="min-width: 55px; cursor: pointer"
              >
                <div class="cellListE1" style="justify-content: center">
                  <span
                    [ngStyle]="{
                      color:
                        mostrarAlertasColor(gestionhija).totalAlertas > 0
                          ? '#c38d08'
                          : 'black'
                    }"
                  >
                    {{ mostrarAlertasColor(gestionhija).totalAlertas }}
                  </span>
                </div>
              </div>

              <!-- Columna 20: Incidencias -->
              <div class="cellListP" style="min-width: 75px">
                <div class="cellListE1" style="justify-content: center">
                  <span>{{ gestionhija.Incidencias?.length }}</span>
                </div>
              </div>

              <!-- Columna 21: Casos -->
              <div class="cellListP" style="min-width: 55px">
                <div class="cellListE1" style="justify-content: center">
                  <span>{{ gestionhija.Casos?.length }}</span>
                </div>
              </div>

              <!-- Columna 22: Carga -->
              <div class="cellListP" style="min-width: 55px">
                <div class="cellListE1" style="justify-content: center">
                  <button
                    class="buttonTransparente"
                    (click)="EventModalCarga(gestionhija)"
                  >
                    <img
                      src="../../../assets/icons/Cargas.png"
                      alt="Cargas"
                      style="height: 24px"
                    />
                  </button>
                </div>
              </div>

              <!-- Columna 23: Bitácora -->
              <div class="cellListP" style="min-width: 55px">
                <div class="cellListE1" style="justify-content: center">
                  <button
                    class="buttonTransparente"
                    (click)="EventModalBitacora(gestionhija)"
                  >
                    <img
                      src="../../../assets/icons/bitacora.png"
                      alt="Bitácora"
                      style="height: 24px"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--</div>-->
</mat-dialog-content>
